import "./ClientRegistrationMedicalHistoryFemalesOnlyComponent.scss";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {ImageConfig, Misc} from "../../../../constants";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import * as Yup from "yup";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import FormikRadioButtonGroupComponent
    from "../../../../shared/components/form-controls/formik-radio-button-group/FormikRadioButtonGroupComponent";
import HorizontalLineComponent
    from "../../../../shared/components/horizontal-line/horizontal-line/HorizontalLineComponent";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import DataLabelValueComponent from "../../../../shared/components/data-label-value/DataLabelValueComponent";
import {setFormChangesData} from "../../../../store/actions/form-state.action";

interface ClientRegistrationMedicalHistoryFemalesOnlyComponentProps {
    onNext: () => void;
    appointmentId: any
}


const ClientMedicalFemaleOnlyValidationSchema = Yup.object({
    females_only_questions: Yup.object({
        "Pregnant or trying to get pregnant?": Yup.string().required('Pregnant or trying to get pregnant is required'),
        "Nursing?": Yup.string().required('Nursing is required')
    }),
});

const ClientMedicalFemaleOnlyInitialValues: any = {
    "females_only_questions": {
        "Pregnant or trying to get pregnant?": "",
        "Nursing?": ""
    }
};

const FormQuestions = [
    {
        key: "Pregnant or trying to get pregnant?",
        title: "Pregnant or attempting to get pregnant?",
    },
    {
        key: "Nursing?",
        title: "Nursing?",
    }
]

const ClientRegistrationMedicalHistoryFemalesOnlyComponent = (props: ClientRegistrationMedicalHistoryFemalesOnlyComponentProps) => {

    const {onNext, appointmentId} = props;
    const [clientMedicalFemaleOnlyInitialValues, setClientMedicalFemaleOnlyInitialValues] = useState<any>(_.cloneDeep(ClientMedicalFemaleOnlyInitialValues));
    const dispatch = useDispatch();
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    const {
        clientMedicalHistoryDetails,
    } = useSelector((state: IRootReducerState) => state.client);

    useEffect(() => {
        if (clientMedicalHistoryDetails) {
            setClientMedicalFemaleOnlyInitialValues({
                females_only_questions: clientMedicalHistoryDetails.females_only_questions
            });
        }
    }, [clientMedicalHistoryDetails]);

    const onSubmit = useCallback((values: any, {setErrors, setSubmitting}: FormikHelpers<any>) => {
        const payload = {
            ...values,
            appointment_id: appointmentId ? appointmentId : currentUser?.appointment_id,
            client_id: currentUser?._id
        };
        setSubmitting(true);
        CommonService._client.ClientMedicalHistoryFemaleOnlyDetailsSaveAPICall(payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setSubmitting(false);
                setClientMedicalFemaleOnlyInitialValues(_.cloneDeep(values));
                dispatch(setFormChangesData(false));
                onNext();
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                setSubmitting(false);
            })
    }, [onNext, currentUser, dispatch, appointmentId]);


    return (
        <div className={'client-registration-medical-history-females-only-component'}>
            <DataLabelValueComponent label={''}>Are you currently:</DataLabelValueComponent>
            <Formik
                validationSchema={ClientMedicalFemaleOnlyValidationSchema}
                initialValues={clientMedicalFemaleOnlyInitialValues}
                onSubmit={onSubmit}
                validateOnChange={false}
                validateOnBlur={true}
                enableReinitialize={true}
                validateOnMount={true}>
                {({values, isValid, isSubmitting, validateForm, dirty}) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                        if (dirty) {
                            dispatch(setFormChangesData(true));
                        }
                    }, [validateForm, values, dirty]);
                    return (
                        <Form noValidate={true} className={"t-form"}>
                            <div className="t-form-controls">
                                {
                                    FormQuestions.map((question: any, index) => {
                                        const {key, title} = question;
                                        return <>
                                            <div className="ts-row ts-align-items-center" key={key}>
                                                <div className="ts-col-md-9 font-weight-500">
                                                    {title}*
                                                </div>
                                                <div className="ts-col-md-3 pdd-top-20">
                                                    <Field name={`females_only_questions.${key}`}>
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikRadioButtonGroupComponent
                                                                    options={CommonService._staticData.yesNoOptions}
                                                                    displayWith={(option) => option.title}
                                                                    valueExtractor={(option) => option.title}
                                                                    required={true}
                                                                    formikField={field}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                </div>
                                            </div>
                                            {index !== FormQuestions.length - 1 &&
                                                <HorizontalLineComponent className={'mrg-bottom-10'}
                                                                         marginBottom={true}/>}
                                        </>
                                    })
                                }
                                <div className="t-form-actions mrg-top-30">
                                    <ButtonComponent
                                        id={"next_btn"}
                                        type={"submit"}
                                        size={'large'}
                                        isLoading={isSubmitting}
                                        disabled={isSubmitting || !isValid}
                                        suffixIcon={<ImageConfig.ArrowRightCircle/>}
                                    >
                                        Next
                                    </ButtonComponent>
                                </div>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    );

};

export default ClientRegistrationMedicalHistoryFemalesOnlyComponent;
